import {BrowserModule} from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {AppComponent} from './app.component';
import {HttpClientModule} from '@angular/common/http';
import {AmplifyAngularModule, AmplifyService} from 'aws-amplify-angular';
import {ZXingScannerModule} from '@zxing/ngx-scanner';
import {PdfViewerModule} from 'ng2-pdf-viewer';


import {HeaderComponent} from './components/common/header/header.component';
import {VideoPageComponent} from './components/video-page/video-page.component';
import {ScanComponent} from './components/scan/scan.component';
import {ModalDialogComponent} from './components/common/modal-dialog/modal-dialog.component';
import { CameraCornersComponent } from './components/camera-corners/camera-corners.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';


@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    VideoPageComponent,
    ScanComponent,
    ModalDialogComponent,
    CameraCornersComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AmplifyAngularModule,
    HttpClientModule,
    ZXingScannerModule,
    PdfViewerModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [AmplifyService],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
}
